import { PlusOutlined } from "@ant-design/icons";
import { Button, Form, Row, Space, Spin, Table } from "antd";
import { useEffect, useRef, useState } from "react";
import ModalCustom from "../../components/ModalCustom/ModalCustom";
import InputFields from "../../components/InputFields/InputFields";
import { columnsTableList, dataAddUser, userSearch } from "./config";
import user from "../../api/user";
import Notification from "../../components/Notification";
import ListActionButton from "../../components/ListActionButton/ActionListButton";
import { ROLES } from "../../type/roles";
import Search from "../../components/Search/Search";

export const User = () => {
  const [loading, setLoading] = useState(false);
  const [validateDataAddUser, setValidateDataAddUser] = useState(dataAddUser);

  const [data, setData] = useState([]);
  const [params, setParams] = useState({
    page: 1,
    limit: 20,
  });
  const [total, setTotal] = useState();
  const addUser = useRef();
  const [formAddUser] = Form.useForm();
  const userSearchRef = useRef();

  const [textModalUser, setTextModalUser] = useState({
    text: "Thêm mới",
    status: 0,
  });
  const onChangePagination = (page, limit) => {
    setParams({ ...params, page: page, limit: limit });
  };

  const [idUser, setIdUser] = useState(null);

  const getListUser = async () => {
    try {
      const res = await user.getListUser(params);
      setData(res.data.data);
      setTotal(res.data.total);
      Notification("success", "Lấy danh sách mẫu hợp đồng thành công");
    } catch (error) {
      Notification("error", "Lấy danh sách mẫu hợp đồng không thành công");
    }
  };

  const handleAddStaff = async () => {
    setLoading(true);
    setTextModalUser({
      status: 0,
      text: "Thêm mới",
    });
    try {
      const data = await formAddUser.validateFields();
      await user.addUser({
        ...data,
        roles: [data.roles],
      });
      addUser.current.closeModal();
      Notification("success", "Tạo mới thành công");
      formAddUser.resetFields();
      getListUser();
      setLoading(false);
    } catch (error) {
      Notification("error", "Tạo mới không thành công");
      setLoading(false);
    }
  };

  const handleEditStaff = async () => {
    try {
      const data = await formAddUser.validateFields();
      await user.updateUser({
        ...data,
        id: idUser,
      });
      addUser.current.closeModal();
      getListUser();
      Notification("success", "Cập nhật thành công");
      formAddUser.resetFields();
      setIdUser(null);
    } catch (error) {
      Notification("error", "Cập nhật không thành công");
    }
  };

  const handleDeleteStaff = async (id) => {
    try {
      await user.deleteUser({ id: id });
      Notification("success", "Xoá thành công");
      formAddUser.resetFields();
      setIdUser(null);
      getListUser();
    } catch (error) {
      Notification("error", "Xoá không thành công");
    }
  };

  const getListLeader = async () => {
    try {
      const res = await user.getListLeader();
      const options = res.data.map((opt) => ({
        label: opt.fullName,
        value: opt.id,
      }));
      return options;
    } catch (error) {
      Notification("error", "Lấy danh sách leader không thành công");
    }
  };

  const checkRolesUser = async () => {
    const optionsLeaders = await getListLeader();

    const roles = localStorage.getItem("roles");
    const newFields = validateDataAddUser.map((item) => {
      if (item.name === "roles") {
        // Lấy danh sách options gốc

        const updatedOptions = item.options.map((opt) => {
          // Nếu người dùng là admin => không disable gì cả
          if (roles.includes(ROLES.ROLE_ADMIN)) {
            return opt;
          }

          // Nếu là leader => disable hai vai trò đầu (admin và leader)
          console.log("🚀 ~ User ~ roles:", roles);
          if (roles.includes(ROLES.ROLE_LEADER)) {
            if (
              opt.value === ROLES.ROLE_ADMIN ||
              opt.value === ROLES.ROLE_LEADER
            ) {
              return { ...opt, disabled: true };
            }
          }

          // Nếu là staff => disable tất cả trừ chính nó
          if (roles === ROLES.ROLE_STAFF) {
            if (opt.value !== ROLES.ROLE_STAFF) {
              return { ...opt, disabled: true };
            }
          }

          return opt;
        });
        // Trả về field roles mới với options đã xử lý
        return {
          ...item,
          options: updatedOptions,
        };
      }
      if (roles.includes(ROLES.ROLE_LEADER)) {
        if (item.name === "leadTeamUserId") {
          return {
            ...item,
            disabled: true,
          };
        }
      }
      if (item.name === "leadTeamUserId") {
        return {
          ...item,
          options: optionsLeaders,
        };
      }
      // Các field khác giữ nguyên
      return { ...item };
    });
    setValidateDataAddUser(newFields);
  };
  const handleCreateUser = async () => {
    addUser.current.openModal();
    formAddUser.resetFields();

    setTextModalUser({
      status: 0,
      text: "Tạo mới",
    });
    checkRolesUser();
  };

  columnsTableList.map((e) => {
    if (e.key === "stt") {
      return {
        ...e,
        render: (text, record, index) =>
          (params.page - 1) * params.limit + index + 1,
      };
    }
    if (e.key == "action") {
      e.render = (_, record, index) => {
        return (
          <ListActionButton
            deleteFunction={() => {
              handleDeleteStaff(record.id);
            }}
            editFunction={() => {
              checkRolesUser();
              formAddUser.setFieldsValue(record);
              addUser.current.openModal();
              setIdUser(record.id);
              setTextModalUser({
                status: 1,
                text: "Chỉnh sửa",
              });
            }}
          />
        );
      };
    }
  });

  //
  useEffect(() => {
    getListUser();
  }, [params]);

  const handleSearch = () => {
    const data = userSearchRef.current.getData();
    setParams({
      ...params,
      ...data,
      page: 1,
    });
  };
  return (
    <Spin spinning={loading}>
      <div className="container">
        <div
          onKeyDown={(e) => {
            if (e.keyCode === 13) {
              handleSearch();
            }
          }}
        >
          <Search
            fields={userSearch}
            onClickSearch={handleSearch}
            ref={userSearchRef}
          />
        </div>
      </div>
      <div className="container">
        <Space direction="vertical" size="large" style={{ width: "100%" }}>
          <Row justify="space-between">
            <div className="title">Quản lý tài khoản</div>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => handleCreateUser()}
            >
              Tạo mới thành viên
            </Button>
          </Row>
          <Table
            columns={columnsTableList}
            dataSource={data}
            pagination={{
              position: ["bottomRight"],
              showSizeChanger: true,
              total: total,
              current: params.page,
              pageSize: params.limit,
              onChange: onChangePagination,
            }}
            bordered
          />
          <ModalCustom
            ref={addUser}
            title={`${textModalUser.text} thành viên`.toLocaleUpperCase()}
          >
            <Space
              direction="vertical"
              size={"large"}
              style={{
                width: "100%",
              }}
            >
              <Form form={formAddUser}>
                <Row gutter={[16, 8]}>
                  <InputFields data={validateDataAddUser} />
                </Row>
              </Form>
              <Row justify={"end"}>
                <Space đirection="horizontal" size="small">
                  <Button
                    type="primary"
                    onClick={
                      textModalUser.status === 0
                        ? handleAddStaff
                        : handleEditStaff
                    }
                  >
                    {`${textModalUser.text}`} thành viên
                  </Button>
                  <Button danger onClick={() => addUser.current.closeModal()}>
                    Hủy
                  </Button>
                </Space>
              </Row>
            </Space>
          </ModalCustom>
        </Space>
      </div>
    </Spin>
  );
};
